var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',{attrs:{"fluid":true}},[_c('formulario-oferta')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }